export default __webpack_public_path__ + "static/media/githubBar.712e2b0f.svg";